// extracted by mini-css-extract-plugin
module.exports = {"layer":"_2787e5dfdf--layer--U8MeQ"};